import classifyApiList from "./basic/classifyApiList";
import brandApiList from "./basic/brandApiList";
import goodsApiList from "./basic/goodsApiList";
import orderApiList from "./basic/orderApiList";
import reportApiList from "./basic/reportApiList";
import aftersaleApiList from "./basic/aftersaleApiList";
import exportApiReport from "./basic/exportApiReport";
import jzbApiList from "./basic/jzbApiList";
import tsApi from "./basic/ts";
import sysMessage from "./basic/sysMessage";

/* eslint-disable no-undef */
const host = hostname;

const commonApiList = {
  login: "/passport/login",
  print: "/manage/order/order/printBox",
  audioOrder: "/manage/order/order/isHaveNewOrder", // 语音播报订单
  // getShopType: '/manage/shop/shop/getShopType', // 获取是否直发
  getShopDetail: "/manage/shop/shop/get", // 获取店铺信息
  getSettleType: "/pay/settle-type" // 获取R4供应商权限
};
// console.log(tsApi, 'tsApi')
let apiList = Object.assign(
  commonApiList,
  classifyApiList,
  brandApiList,
  goodsApiList,
  orderApiList,
  reportApiList,
  aftersaleApiList,
  exportApiReport,
  jzbApiList,
  sysMessage,
  tsApi
);
for (let i in apiList) {
  apiList[i] = host + apiList[i];
}
// console.log("apiList:99999999", apiList);
export default apiList;



// WEBPACK FOOTER //
// ./src/service/apiList.js